export class Overlay {
	/**
	 * Initialize overlay functionality
	 */
	constructor() {
		this.overlays = document.querySelectorAll(".overlay");
		this.triggers = document.querySelectorAll(".button[aria-controls]");

		this.init();
	}

	/**
	 * Initialize all overlays
	 * @private
	 */
	init() {
		this.triggers.forEach((trigger) => this.setupTrigger(trigger));
		this.overlays.forEach((overlay) => this.setupOverlay(overlay));
	}

	/**
	 * Find the trigger that currently has this overlay open
	 * @private
	 * @param {HTMLDialogElement} overlay
	 * @returns {HTMLButtonElement|null}
	 */
	getActiveTrigger(overlay) {
		return document.querySelector(`[aria-controls="${overlay.id}"][aria-expanded="true"]`);
	}

	/**
	 * Set up click handler for an overlay trigger
	 * @private
	 * @param {HTMLButtonElement} trigger
	 */
	setupTrigger(trigger) {
		const overlayId = trigger.getAttribute("aria-controls");
		const overlay = document.getElementById(overlayId);

		if (!overlay || !overlay.classList.contains("overlay")) return;

		trigger.addEventListener("click", () => {
			if (overlay.open) {
				this.closeOverlay(overlay);
			} else {
				// Close any other open overlays first
				this.closeAllOverlays();
				this.openOverlay(overlay, trigger);
			}
		});
	}

	/**
	 * Set up overlay close handlers
	 * @private
	 * @param {HTMLDialogElement} overlay
	 */
	setupOverlay(overlay) {
		// Close button
		const closeButton = overlay.querySelector(".overlay__close");
		if (closeButton) {
			closeButton.addEventListener("click", () => {
				this.closeOverlay(overlay);
			});
		}

		// Handle native close (ESC key, closedby="any" backdrop click)
		overlay.addEventListener("close", () => {
			const trigger = this.getActiveTrigger(overlay);
			if (trigger) {
				trigger.setAttribute("aria-expanded", "false");
			}
			document.body.style.overflow = "";
		});
	}

	/**
	 * Open an overlay
	 * @private
	 * @param {HTMLDialogElement} overlay
	 * @param {HTMLButtonElement} trigger
	 */
	openOverlay(overlay, trigger) {
		overlay.showModal();

		if (trigger) {
			trigger.setAttribute("aria-expanded", "true");
		}
	}

	/**
	 * Close an overlay
	 * @private
	 * @param {HTMLDialogElement} overlay
	 */
	closeOverlay(overlay) {
		const trigger = this.getActiveTrigger(overlay);
		overlay.close();

		if (trigger) {
			trigger.setAttribute("aria-expanded", "false");
		}
	}

	/**
	 * Close all open overlays
	 * @private
	 */
	closeAllOverlays() {
		this.overlays.forEach((overlay) => {
			if (overlay.open) {
				this.closeOverlay(overlay);
			}
		});
	}
}
